{
  "hero": {
    "title": "Energy-Fintech solutions",
    "highlight": "for the energy transition",
    "subtitle": "We are redefining how renewable energy is consumed and produced. Discover our solutions for companies and producers."
  },
  "fork": {
    "companies": {
      "title": "For companies",
      "desc": "Without selling you energy, we lower your energy costs while elevating your sustainability.",
      "ctaShort": "See the solutions"
    },
    "producers": {
      "title": "For producers",
      "desc": "Without selling your plants or taking on more debt, you get immediate cash and derisking.",
      "ctaShort": "See the solutions"
    },
    "capital": {
      "title": "For investors",
      "desc": "Acquire revenue shares in renewable plants already in operation, without buying the assets.",
      "ctaShort": "Discover DEC Capital"
    }
  }
}
